import { render, staticRenderFns } from "./product_designs.vue?vue&type=template&id=d3e5c32e&scoped=true"
import script from "./product_designs.vue?vue&type=script&lang=js"
export * from "./product_designs.vue?vue&type=script&lang=js"
import style0 from "./product_designs.vue?vue&type=style&index=0&id=d3e5c32e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e5c32e",
  null
  
)

export default component.exports